const RappiManager = ({ shouldOpenModal: _shouldOpenModal, sharedLocalData, loadingBaseData }) => {
    const { estabSelected, storeSelected } = sharedLocalData || {};

    return (
        <>
            {!estabSelected || !storeSelected ? (
                <div className="alert alert-info">
                    <p>Selecione estabelecimento e loja para continuar.</p>
                </div>
            ) : loadingBaseData ? (
                <div className="alert alert-secondary">
                    <p>Carregando dados base...</p>
                </div>
            ) : null}
            <div className="alert alert-warning">
                <p>Em desenvolvimento...</p>
            </div>
        </>
    )
}

export default RappiManager
